import { useQuery } from '@tanstack/react-query';

import { staffApi } from '../api/staff';

export const useGetPermissions = () => {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => staffApi.getPermissions(),
  });
};
